import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=b2183a16"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
import style0 from "./InputField.vue?vue&type=style&index=0&id=b2183a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports